import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import { FormControl } from 'baseui/form-control'
import getError from '@/containers/SubscriptionFormPage/getError'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'

const Province = () => {
  const { t, errors, province, showProvince, showAddressFields } = useAddress()

  if (!showProvince || !showAddressFields) {
    return null
  }

  return (
    <FormControl error={getError('province', errors)}>
      <SDInput
        label={t('subscriptionForm:address_module.readonly_province')}
        currentValue={province}
        readOnly={true}
        disabled={true}
      />
    </FormControl>
  )
}

export default Province
